import axios from 'axios';
import config from '../config';
import { getActAsEmail } from '../contexts/ImpersonationContext';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
});

let clerkSession = null;

export const setClerkSession = (session) => {
  clerkSession = session;
};

// Keep backward compat · accepted for older callers, intentional no-op
// eslint-disable-next-line no-unused-vars
export const setClerkTokenGetter = (_getter) => {};

/* Read the active Clerk session at request time · Clerk attaches itself
 * to window.Clerk as soon as its SDK boots, which is BEFORE any of our
 * React providers run their effects. Relying on the module-level
 * `clerkSession` (set by AuthProvider's useEffect) would race against
 * top-level providers like AppCatalogueProvider whose own effects fire
 * before their parent's · their requests would go out unauthenticated
 * and 403 even though the user is signed in. Falling back to the
 * module var keeps tests / non-Clerk callers working. */
const getActiveSession = () => {
  if (typeof window !== 'undefined' && window.Clerk?.session) {
    return window.Clerk.session;
  }
  return clerkSession;
};

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    const active = getActiveSession();
    if (active) {
      try {
        const token = await active.getToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('[axios] Failed to get token:', err);
      }
    }
    // Admin act-as · backend swaps request.user when the real user is_admin.
    // Header sent on every request so navigation, GETs and writes are all
    // consistently attributed to the impersonated user.
    const actAs = getActAsEmail();
    if (actAs) {
      requestConfig.headers['X-Impersonate-User-Email'] = actAs;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// A deactivated employee (left the company) is refused by the API · tell
// the page once, so it can show a clear message instead of broken screens.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.data?.code === 'account_deactivated' && !window.__ltDeactivated) {
      window.__ltDeactivated = true;
      window.dispatchEvent(new Event('lt:deactivated'));
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
